import { useCallback } from 'react'
import type { StakeholderRating, FeedbackType, FeedbackContext } from '@bandos/shared'
import { useOptionalChatWindow } from '../../../Sidebars/ChatWindow/useChatWindowContext'
import { useStakeholderContext } from '../../../../../features/stakeholder'
import type { ChatTarget } from '../../../../../context/ScopedChatContext'

interface UseScopedChatHandlerResult {
  handleOpenScopedChat: (
    rater: StakeholderRating,
    feedbackType: FeedbackType,
    feedbackContent: string
  ) => void
  hasChatContext: boolean
}

export function useScopedChatHandler(ideaLabel: string): UseScopedChatHandlerResult {
  const chatWindow = useOptionalChatWindow()
  const { projectStakeholders } = useStakeholderContext()

  const handleOpenScopedChat = useCallback(
    (rater: StakeholderRating, feedbackType: FeedbackType, feedbackContent: string) => {
      if (!chatWindow) return

      const target: ChatTarget = {
        type: 'stakeholder',
        id: projectStakeholders.find((s) => s.template?.name === rater.name)?.id,
        name: rater.name,
        role: rater.role,
      }

      const feedbackContext: FeedbackContext = {
        feedbackType,
        feedbackContent,
        ideaLabel,
        raterName: rater.name,
        raterRole: rater.role,
        rating: rater.rating,
      }

      chatWindow.openScopedChat(target, feedbackContext)
    },
    [chatWindow, projectStakeholders, ideaLabel]
  )

  return { handleOpenScopedChat, hasChatContext: !!chatWindow }
}
